module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padded"
  }, [_c(_vm.titleStyle, {
    tag: "component"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('span', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": _vm.openAddForm
    }
  }, [_vm._v("Add")]), _vm._v("\n     \n    "), (_vm.formList && _vm.formList.length > 0) ? _c('el-button', {
    attrs: {
      "size": "mini",
      "type": "success"
    },
    on: {
      "click": _vm.saveForm
    }
  }, [_vm._v("Save")]) : _vm._e()], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.formTitle,
      "visible": _vm.showForm
    },
    on: {
      "update:visible": function($event) {
        _vm.showForm = $event
      }
    }
  }, [_c('form-editor', {
    model: {
      value: (_vm.form),
      callback: function($$v) {
        _vm.form = $$v
      },
      expression: "form"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.clearForm
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success",
      "disabled": !_vm.form.dataType && !_vm.form.label
    },
    on: {
      "click": _vm.addFormItem
    }
  }, [_vm._v("Save")])], 1)], 1), _vm._v(" "), (_vm.formList && _vm.formList.length > 0) ? _c('section', [_c('el-tabs', [_c('el-tab-pane', {
    attrs: {
      "label": "Design"
    }
  }, [_c('el-table', {
    class: _vm.tableStyle,
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.formList
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('form-editor', {
          model: {
            value: (props.row),
            callback: function($$v) {
              _vm.$set(props, "row", $$v)
            },
            expression: "props.row"
          }
        })]
      }
    }], null, false, 2840191951)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Label",
      "prop": "label"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              " + _vm._s(_vm.ellipsis(scope.row.label)) + " "), _c('i', {
          class: scope.row.required ? 'fa fa-star' : ''
        })]
      }
    }], null, false, 3999305326)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Type",
      "prop": "dataType"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              " + _vm._s(scope.row.dataType) + " \n              "), (scope.row.gutter) ? _c('span', {
          staticClass: "text-muted"
        }, [_vm._v(" [" + _vm._s(scope.row.gutter) + "]")]) : _vm._e(), _vm._v(" "), (scope.row.span) ? _c('span', {
          staticClass: "text-muted"
        }, [_vm._v(" [" + _vm._s(scope.row.span) + "]")]) : _vm._e(), _vm._v(" "), (scope.row.decimals) ? _c('span', {
          staticClass: "text-muted"
        }, [_vm._v(" [" + _vm._s(scope.row.decimals) + "]")]) : _vm._e(), _vm._v(" "), (scope.row.list && scope.row.list.length > 0) ? _c('span', {
          staticClass: "text-muted"
        }, [_vm._v(" " + _vm._s(scope.row.list))]) : _vm._e()]
      }
    }], null, false, 1481357698)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "danger",
            "circle": ""
          },
          on: {
            "click": function($event) {
              return _vm.deleteItem(scope.$index, scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash-alt"
        })])]
      }
    }], null, false, 284994114)
  })], 1), _vm._v(" "), _c('JSONView', {
    attrs: {
      "data": _vm.formList
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Preview"
    }
  }, [_c('form-viewer', {
    model: {
      value: (this.formList),
      callback: function($$v) {
        _vm.$set(this, "formList", $$v)
      },
      expression: "this.formList"
    }
  })], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28e8a9e5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/forms/FormBuilder.vue
// module id = 1383
// module chunks = 0